import Review from './Review';

export type { ReviewProps } from './Review';
export type { ReviewData, ReviewReply } from './types';

export default Review;
